export default {
  path: '/parking_fees',
  component: () => import('@/layouts/PublicLayout'),
  children: [
    {
      path: 'parking_relief_entrypoint',
      component: () => import('@/views/parking_fees/ParkingReliefEntrypoint'),
      meta: {
        title: '停车减免'
      }
    },
    {
      path: 'parking_relief_result',
      component: () => import('@/views/parking_fees/ParkingReliefResult'),
      meta: {
        title: '停车减免结果'
      }
    },
    {
      path: 'parking_relief_iframe',
      component: () => import('@/views/parking_fees/ParkingReliefIframe'),
      meta: {
        title: '停车减免结果'
      }
    },
    {
      path: 'parking_relief_qrcode',
      component: () => import('@/views/parking_fees/ParkingReliefQrcode'),
      meta: {
        title: '停车减免结果'
      }
    },
    // 以下作废

    {
      path: 'qrcode_relief',
      component: () => import('@/views/parking_fees/QrcodeRelief'),
      meta: {
        title: '扫码停车减免'
      }
    },
    {
      path: 'page_relief',
      component: () => import('@/views/parking_fees/PageRelief'),
      meta: {
        title: '充电停车减免'
      }
    }
  ]
}
